export default __webpack_public_path__ + "media/images/images_v2/fondliste-dcc6827dad95fd438f599fb3c2e00caf.png";